module.exports = __webpack_public_path__ + "static/media/71 - Maya - Lait de coco (Dub).8515ec44.mp3";